import { IDataPermissionGroup, IGroupPermission } from './data';
import { API } from '@/services/typings';
import { request } from '@umijs/max';

export const getGroupPermissions = async () => {
  const res = await request<API.DataResponse<IGroupPermission>>('v1/cms/permission-group/list', {
    method: 'GET',
  });
  return res.data;
};

export const removeGroupPermission = async (id: string) => {
  const res = await request<API.DataResponse<boolean>>(`v1/cms/permission-group/${id}`, {
    method: 'DELETE',
  });
  return res.data;
};

export const onGetChildrenPermission = async (id: string) => {
  const res = await request<API.DataResponse<IGroupPermission>>(
    `v1/cms/permission-group/detail?id=${id}`,
    {
      method: 'GET',
    },
  );
  return res.data;
};

export const getDefaultPermission = async () => {
  const res = await request<API.DataResponse<IGroupPermission>>(`v1/cms/permission-group/default`);
  return res.data;
};

export const createPermissionGroup = async (data: IDataPermissionGroup) => {
  const res = await request<API.DataResponse<IGroupPermission>>(`v1/cms/permission-group/create`, {
    method: 'POST',
    data,
  });
  return res.data;
};

export const updatePermissionGroup = async (data: IDataPermissionGroup) => {
  const res = await request<API.DataResponse<IGroupPermission>>(`v1/cms/permission-group/update`, {
    method: 'PUT',
    data,
  });
  return res.data;
};

export const getPermissionOfCurrentUser = async () => {
  const res = await request<API.DataResponse<IGroupPermission>>(`v1/cms/admin/permission`, {
    method: 'GET',
  });
  return res.data;
};
